module.exports = __webpack_public_path__ + "img/gourd.287cb745.jpg";